// document.addEventListener("DOMContentLoaded", function () {
//   const buttons = document.querySelectorAll(".wishlist-btn");

//   buttons.forEach((btn) => {
//     btn.addEventListener("click", function () {
//       let handle = this.getAttribute("data-product-handle");
//       let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

//       if (!wishlist.includes(handle)) {
//         wishlist.push(handle);
//         localStorage.setItem("wishlist", JSON.stringify(wishlist));
//         alert("Added to wishlist!");
//       } else {
//         alert("Already in wishlist");
//       }
//     });
//   });
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const buttons = document.querySelectorAll(".wishlist-btn");

//   buttons.forEach((btn) => {
//     btn.addEventListener("click", function () {
//       let handle = this.getAttribute("data-product-handle");
//       let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

//       // Check if exists
//       let exists = wishlist.includes(handle);

//       // Remove existing heart if any
//       let existingHeart = this.parentElement.querySelector(".wishlist_link");
//       if (existingHeart) existingHeart.remove();

//       if (!exists) {
//         // ADD TO WISHLIST
//         wishlist.push(handle);
//         localStorage.setItem("wishlist", JSON.stringify(wishlist));

//         // Add Heart Icon
//         this.insertAdjacentHTML(
//           "afterend",
//           `<a href="/pages/wishlist" target="_blank" class="wishlist_link blank_wl">
//             <svg class="icon icon-heart" viewBox="0 0 290 256">
//               <path d="M258.844192 127.790368L145 241.63456 31.1558082 127.790368c-26.9461761-26.946176-26.9461761-70.6345598 0-97.5807359 26.9461762-26.94617613 70.6345598-26.94617613 97.5807358 0L145 46.4730881l16.263456-16.263456c26.946176-26.94617613 70.63456-26.94617613 97.580736 0 26.946176 26.9461761 26.946176 70.6345599 0 97.5807359z"></path>
//             </svg>
//           </a>`
//         );

//       } else {
//         // REMOVE FROM WISHLIST
//         wishlist = wishlist.filter(item => item !== handle);
//         localStorage.setItem("wishlist", JSON.stringify(wishlist));

//         // Heart removed automatically above
//       }
//     });
//   });
// });


window.initWishlist = function() {
  const buttons = document.querySelectorAll(".wishlist-btn");

  buttons.forEach((btn) => {
    // Avoid double binding
    if (btn.dataset.wishlistInitialized) return;
    btn.dataset.wishlistInitialized = "true";

    let handle = btn.getAttribute("data-product-handle");

    // Check on load – add class if already in wishlist
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    if (wishlist.includes(handle)) {
      btn.classList.add("added-to-wishlist");
    }

    btn.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default anchor behavior if any
      let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

      if (!wishlist.includes(handle)) {
        // Add product
        wishlist.push(handle);
        localStorage.setItem("wishlist", JSON.stringify(wishlist));

        btn.classList.add("added-to-wishlist");
      } else {
        // Remove product
        wishlist = wishlist.filter((item) => item !== handle);
        localStorage.setItem("wishlist", JSON.stringify(wishlist));

        btn.classList.remove("added-to-wishlist");
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  window.initWishlist();
});

